import {Utils} from 'common/scripts/utils';

class ParametricFilterFeatures {
    constructor(options) {
        this.options = options;
        this.element = options.element;
        this.openClass = 'is-open';
        this.isOpen = false;
    }

    init() {
        if (!this.element) {
            return;
        }

        this._initElements();
        this._bindEvents();
        this._setInitState();
    }

    _initElements() {
        this.toggle = this.element.querySelector('.j-parametric-filter__features-toggle');
        this.content = this.element.querySelector('.j-parametric-filter__dropdown');
        this.count = this.element.querySelector('.j-parametric-filter__features-count') || null;
        this.inputs = Array.from(this.element.querySelectorAll('input'));
    }

    _bindEvents() {
        this.toggle.addEventListener('click', () => {
            const method = this.isOpen ? 'close' : 'open';

            this[method]();
        });

        // this.element.addEventListener('change', () => {
        //    this._changeCount();
        // });
    }

    _setInitState() {
        this[this._getCount() > 0 ? 'open' : 'close']();
        // this._changeCount();
    }

    _changeCount() {
        const count = this._getCount();

        this.count.innerHTML = count === 0 ? '' : count;
        this.count.classList.toggle('is-show', count !== 0);
    }

    _getCount() {
        return this.element.querySelectorAll('input:checked').length;
    }

    _scrollIntoView() {
        const rect = this.element.getBoundingClientRect();

        if ((rect.top + rect.height) <= Utils.getWindowHeight()) {
            return;
        }

        this.element.scrollIntoView({
            behavior: 'smooth'
        });
    }

    open() {
        this.isOpen = true;
        this.element.classList.add(this.openClass);
        $(this.content).slideDown(300, () => {
            this._scrollIntoView();

            if (this.options.update) {
                this.options.update();
            }
        });
    }

    close() {
        this.isOpen = false;
        $(this.content).slideUp(300, () => {
            if (this.options.update) {
                this.options.update();
            }
        });
        this.element.classList.remove(this.openClass);
    }

    // update() {
    //    this._changeCount();
    // }
}

export default ParametricFilterFeatures;
